import styled from "styled-components/macro"
import Color from "../../../constants/Color"
import { Link } from "react-router-dom"

export const Container = styled(Link)`
  width: 100%;
`

export const Thumbnail = styled.div`
  height: 268px;
  overflow: hidden;
  border-radius: 4px;
  margin-bottom: 6px;
  background: ${Color.gray200};
`

export const ThumbSkeleton = styled.div`
  width: 100%;
  height: 268px;
  border-radius: 6px;
  margin-bottom: 6px;
  background: ${Color.gray200};
`

export const Image = styled.img`
  width: 100%;
  height: 268px;
  object-fit: cover;
  border-radius: 6px;
  margin-bottom: 6px;
  background: ${Color.gray200};
  border: none;
`

export const Name = styled.h4`
  width: 100%;
  font-size: 16px;
  font-weight: 600;
  color: ${Color.gray800};
  margin-bottom: 4px;

  @media (min-width: 1280px) {
    font-size: 18px;
  }
`
export const InMovieName = styled.p`
  width: 100%;
  font-size: 14px;
  color: ${Color.gray400};
  @media (min-width: 1280px) {
    font-size: 16px;
  }
`
